<script module lang="ts">
	export type Location = {
		latitude: number;
		longitude: number;
	};
</script>

<script lang="ts">
	import { PUBLIC_MAPBOX_TOKEN } from '$env/static/public';

	interface Props {
		location: Location;
	}

	let { location }: Props = $props();

	let { latitude, longitude } = $derived(location);

	let src = $derived(
		`https://api.mapbox.com/styles/v1/sistrall/cjespbyi113jl2rpggco6g0k5/static/pin-l-s+FBCA62(${longitude},${latitude})/${longitude},${latitude},9,0/800x200?access_token=${PUBLIC_MAPBOX_TOKEN}`
	);
	let href = $derived(`https://www.google.com/maps?q=${latitude},${longitude}`);
</script>

<a {href} target="_blank"><img {src} alt="" class="border-t rounded-b-lg" /></a>
